(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inscription', {
                parent: 'app',
                url: '/inscription',
                title: 'Inscriptions',
                sidebarMeta: {
                    icon: 'fa fa-user-plus',
                    order: 1
                },
                data: {
                    authorities: ['ROLE_RESPONSABLE_INSCRIPTION', 'ROLE_RESPONSABLE', 'ROLE_ADMIN'],
                    pageTitle: 'josdaviApp.inscription.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/inscription/inscriptions.html',
                        controller: 'InscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('inscription');
                        $translatePartialLoader.addPart('etatInscription');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
